import { END, eventChannel } from 'redux-saga';
/* eslint-disable no-unused-vars */
import {
  PublicationContext,
  ConnectedContext,
  ErrorContext,
  Centrifuge,
} from 'centrifuge';
/* eslint-enable no-unused-vars */
import { CENTRIFUGO_EVENTS_MAP } from '../constants/centrifugo';

/**
 *
 * @param {Centrifuge} centrifugo
 * @returns {EventChannel<END | {type:CENTRIFUGO_EVENTS_MAP.PUBLICATION
 * | CENTRIFUGO_EVENTS_MAP.CONNECT
 * | CENTRIFUGO_EVENTS_MAP.ERROR, payload: PublicationContext |
 * | ConnectedContext
 * | ErrorContext}>}
 */
export const createCentrifugoChannel = (centrifugo) => {
  return eventChannel((emit) => {
    centrifugo.on('publication', (payload) => {
      emit({ type: CENTRIFUGO_EVENTS_MAP.PUBLICATION, payload });
    });

    centrifugo.on('connected', (payload) => {
      emit({ type: CENTRIFUGO_EVENTS_MAP.CONNECT, payload });
    });

    centrifugo.on('error', (payload) => {
      emit({ type: CENTRIFUGO_EVENTS_MAP.ERROR, payload });
      emit(END);
    });
    centrifugo.on('disconnected', () => {
      emit({ type: CENTRIFUGO_EVENTS_MAP.DISCONNECT });
      emit(END);
    });

    centrifugo.connect();

    return () => {
      // emit end
      emit(END);
      centrifugo.disconnect();
    };
  });
};
